<template>
  <div class="table-box">
    <global-tag>
      <el-form label-width="120px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="姓名：">
              <el-input
                clearable
                v-model="query.personName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="手机号码：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="query.personPhone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="所属机构：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="query.serviceStationName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="本月是否有工单:">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                clearable
                v-model="query.isMouth"
              >
                <el-option label="是" :value="0"></el-option>
                <el-option label="否" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="本季度是否有工单:" label-width="130px">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                clearable
                v-model="query.idQuarter"
              >
                <el-option label="是" :value="0"></el-option>
                <el-option label="否" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-button type="primary" class="searchBtns" @click="QuerySearch"
              >查询
            </el-button>
            <el-button type="info" class="resetReach" @click="emptySearch"
              >重置
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div>
      <div class="btn_group">
        <el-button-group>
          <el-button
            type="success"
            size="small"
            icon="el-icon-plus"
            class="openBtns"
            @click="addPersonnelHandle('新增')"
            >新增
          </el-button>
          <el-button
          type="primary"
          icon="el-icon-download"
          class="button downOutBtns"
          style="margin-left:20px"
          @click="createExcel"
          >导出
        </el-button>
        </el-button-group>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-style="{
            background: '#f2f2f2',
            color: '#000',
          }"
        >
          <el-table-column
            type="index"
            width="70"
            label="序号"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '序号') !== -1
            "
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="personName"
            min-width="120px"
            label="姓名"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '姓名') !== -1
            "
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="personSex"
            label="性别"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '性别') !== -1
            "
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{ scope.row.personSex == 1 ? "男" : "女" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="personPhone"
            label="手机号码"
            min-width="180px"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '手机号码') !==
              -1
            "
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="personAge"
            label="年龄"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '年龄') !== -1
            "
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '地址') !== -1
            "
            :show-overflow-tooltip="true"
            min-width="120px"
          >
          </el-table-column>
          <el-table-column
            prop="serviceStationName"
            label="机构点"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '机构点') !==
              -1
            "
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            v-if="
              this.tempTableChekbox.findIndex((item) => item === '操作') !== -1
            "
            width="150px"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="addPersonnelHandle('查看', scope.row)"
                >查看
              </el-button>
              <el-button
                type="text"
                @click="addPersonnelHandle('编辑', scope.row)"
                >编辑
              </el-button>
              <el-button type="text" @click="deleteHandle(scope.row)"
                >删除
              </el-button>
              <!--              <el-button type="text" @click="workOrder(scope.row)">修改技能</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottom-page">
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo"
          :page-sizes="[10, 20, 40, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount1"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addPersonnelDialogVisible"
      width="58%"
      @close="closeAddDialog"
    >
      <!--      <hr style="margin-bottom: 20px" color="#CCCCCC" />-->

      <div class="name-per">
        <div
          v-for="(item, index) in titleList"
          :key="index"
          class="name-list"
          @click="changeIdx(item.id)"
        >
          <div>
            <div
              class="name-title"
              :class="{
                changeColor: controlAddContent == item.id,
              }"
            >
              <div></div>
              <div><i class="el-icon-circle-check"></i></div>
              <div></div>
            </div>
            <div class="name-bottom">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <!-- 基本信息 -->
      <el-form
        v-show="controlAddContent == 1"
        :model="formData"
        :rules="formDataRules"
        ref="addformRef"
        :disabled="dialogTitle === '查看'"
        label-width="110px"
      >
        <div class="infoBox">
          <div>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名:" prop="serviceStaffId">
                  <el-select
                    v-model="formData.serviceStaffId"
                    filterable
                    remote
                    :disabled="dialogTitle === '查看' || dialogTitle === '编辑'"
                    ref="fuzzySearch"
                    style="width: 100%"
                    placeholder="请输入关键词"
                    :remote-method="remoteMethod"
                    @change="handleSelect"
                    @click.native="clearForm"
                    :loading="loading"
                    solt="empty"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.personName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号码:" prop="personPhone">
                  <el-input
                    v-model="formData.personPhone"
                    disabled
                    placeholder="请输入"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别:" prop="personSex">
                  <el-select
                    disabled
                    v-model="formData.personSex"
                    placeholder="通过身份证获取"
                    style="width: 100%"
                  >
                    <el-option label="男" :value="'1'"></el-option>
                    <el-option label="女" :value="'2'"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号:" prop="personIdentity">
                  <!-- <el-input
                      v-model="formData.personIdentity"
                      placeholder="请输入"
                      disabled
                      style="width: 100%"
                      @input="idCardchange"
                  ></el-input> -->
                  <el-select
                    v-model="formData.personIdentity"
                    filterable
                    remote
                    style="width: 100%"
                    placeholder="请输入关键词"
                    :disabled="dialogTitle === '查看' || dialogTitle === '编辑'"
                    :remote-method="remoteMethod1"
                    @change="handleSelect"
                    @click.native="clearForm1"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.personIdentity"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="年龄:" prop="personAge">
                  <el-input
                    disabled
                    v-model="formData.personAge"
                    placeholder="通过身份证获取"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职位:">
                  <el-select
                    placeholder="请选择"
                    v-model="formData.position"
                    disabled
                    style="width: 100%"
                  >
                    <el-option label="普通员工" :value="3"></el-option>
                    <el-option label="副站长" :value="2"></el-option>
                    <el-option label="站长" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否上传视频:">
                  <el-select
                    v-model="formData.isUploadVideo"
                    placeholder="请选择"
                    :disabled="dialogTitle === '查看'"
                    style="width: 100%"
                    ref="selectShengChange"
                  >
                    <el-option value="是" label="是"></el-option>
                    <el-option value="否" label="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="家政经验：">
                  <el-select
                    v-model="formData.familyExperience"
                    placeholder="请选择"
                    disabled
                    style="width: 100%"
                    ref="selectShengChange"
                  >
                    <el-option value="0" label="有"></el-option>
                    <el-option value="1" label="无"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开单间隔时间：">
                  <el-input
                    v-model="formData.intervalTime"
                    type="Number"
                    placeholder="请输入开单间隔时间"
                    style="width: 100%"
                    ><template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item label="是否效验服务地址合格：" label-width="200px">
                  <el-radio v-model="formData.checkAddress" label="1"
                        >是
                    </el-radio>
                    <el-radio v-model="formData.checkAddress" label="0"
                        >否
                    </el-radio>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item label="是否可以取消工单：" label-width="200px">
                  <el-radio v-model="formData.canInvalid" label="1"
                        >是
                    </el-radio>
                    <el-radio v-model="formData.canInvalid" label="0"
                        >否
                    </el-radio>
                </el-form-item>
              </el-col>
               <el-col :span="12">
                <el-form-item label="是否允许查询全区域服务对象：" label-width="220px">
                  <el-radio v-model="formData.canSelectAllCustomer" label="1"
                        >是
                    </el-radio>
                    <el-radio v-model="formData.canSelectAllCustomer" label="0"
                        >否
                    </el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="formData.isUploadVideo == '是'">
                                
                <el-form-item label="视频开始时间：">
                                    
                  <el-date-picker
                    v-model="formData.videoStartTime"
                    type="date"
                    :picker-options="pickerOptionsStart"
                    style="width: 100%"
                    :disabled="dialogTitle === '查看'"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                                      
                  </el-date-picker>
                </el-form-item>
                               
              </el-col>
                            
              <el-col :span="12" v-if="formData.isUploadVideo == '是'">
                                
                <el-form-item label="视频结束时间：">
                                       
                  <el-date-picker
                    v-model="formData.videoEndTime"
                    :disabled="dialogTitle === '查看'"
                    style="width: 100%"
                    type="date"
                    :picker-options="pickerOptionsEnd"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                  >
                                      
                  </el-date-picker>
                                  
                </el-form-item>
                              
              </el-col>
            </el-row>
          </div>
          <div class="rightBox">
            <el-upload
              ref="upload"
              class="avatar-uploader"
              :action="baseUrl"
              :show-file-list="false"
              disabled
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="formData.personPhoto"
                :src="formData.personPhoto"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!--            <div class="uploadBtn">上传图片</div>-->
          </div>
        </div>
        <el-form-item label="地址:">
          <el-select
            v-model="formData.provinceId"
            disabled
            placeholder="请选择省"
            @change="handleProvince"
            style="width: 20%"
            ref="selectShengChange"
          >
            <el-option
              v-for="(item, index) in provinceList"
              :key="index"
              :label="item.name"
              :value="item.adcode"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.cityId"
            disabled
            placeholder="请选择市"
            @change="handleCity"
            ref="selectShiChange"
            style="width: 20%"
          >
            <el-option
              v-for="(item, index) in cityList"
              :key="index"
              :label="item.name"
              :value="item.adcode"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="formData.areaId"
            disabled
            placeholder="请选择区"
            @change="handleArea"
            ref="selectQuChange"
            style="width: 20%"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.addName"
              :value="item.addCode"
            >
            </el-option>
          </el-select>
          <el-select
            disabled
            v-model="formData.streetId"
            placeholder="请选择街道"
            @change="streetChange"
            style="width: 20%"
            ref="selectJiedaoChange"
          >
            <el-option
              v-for="(item, index) in streetList"
              :key="index"
              :label="item.addName"
              :value="item.addCode"
            >
            </el-option>
          </el-select>
          <!-- @change="handleCommunityChange" -->
          <el-select
            v-model="formData.shequId"
            disabled
            placeholder="请选择社区"
            ref="selectShequChange"
            style="width: 20%"
            @change="handleCommunityChange"
          >
            <el-option
              v-for="item in communityList"
              :key="item.addCode"
              :label="item.addName"
              :value="+item.addCode"
            >
            </el-option>
          </el-select>
          <input
            v-model="formData.address"
            id="tipinput"
            disabled
            class="el-input__inner"
            :class="dialogTitle == '查看' ? 'innerCur' : ''"
            @focus="getMap('tipinput')"
            placeholder="请输入关键字"
            autocomplete="off"
          />
        </el-form-item>
        <div class="map_container" style="margin-bottom: 20px">
          <div id="container1" style="width: 100%; height: 200px"></div>
        </div>
        <el-form-item label="机构点：">
          <el-input
            v-model="formData.serviceStationName"
            disabled
            style="margin-bottom: 20px"
          ></el-input>

          <el-table
            :data="servestation.list"
            border
            highlight-current-row
            style="width: 100%"
            :disabled="dialogTitle === '查看'"
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="statName"
              label="站点名称"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="address"
              label="地址"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="servestationChange"
            @current-change="servestationSize"
            :page-sizes="[10, 20, 40, 100]"
            :page-size="servestation.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="servestation.count"
          >
          </el-pagination>
        </el-form-item>
      </el-form>
      <div v-show="controlAddContent == 2">
        <el-table :data="infoData" border style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="100"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="customerType"
            label="工单类型"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customerType == 1">商业服务工单</span>
              <span v-if="scope.row.customerType == 3">残联服务工单</span>
              <span v-if="scope.row.customerType == 4">老干服务工单</span>
              <span v-if="scope.row.customerType == 6">民政服务工单</span>
              <span v-if="scope.row.customerType == 14">退役军人服务工单</span>
              <!-- <span v-if='scope.row.type === 1'>普通服务工单</span>
<span v-if='scope.row.type === 2'>团购工单</span>
<span v-if='scope.row.type === 3'>兑换工单</span>
<span v-if='scope.row.type === 4'>实体服务工单</span>
<span v-if='scope.row.type === 0'>咨询工单</span> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="customerName"
            label="客户姓名"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="timeStart"
            width="170px"
            label="开始时间"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="timeEnd"
            width="170px"
            label="结束时间"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            prop="states"
            label="状态"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.states === 1">待处理</span>
              <span v-if="scope.row.states === 2">待回访</span>
              <span v-if="scope.row.states === 3">服务完成</span>
              <span v-if="scope.row.states === 4">待作废</span>
              <span v-if="scope.row.states === 5">已作废</span>
              <span v-if="scope.row.states === 6">异常工单</span>
              <span v-if="scope.row.states === 0">待派发</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="age"
            label="操作"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="orderClick(scope.row)"
                >查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
               <div class="bottom-page">
                 <el-pagination
                   @size-change="handleSizeChange2"
                   @current-change="handleCurrentChange2"
                   :page-sizes="[10, 20, 40, 100]"
                   :page-size="query2.pageSize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="totalCount2"
                 >
                 </el-pagination>
               </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :disabled="dialogTitle === '查看'"
          @click="confirmSave"
          >确定</el-button
        >
        <el-button @click="addPersonnelDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 工单信息弹框 -->
    <el-dialog title="工单信息" :visible.sync="infoDialogVisible" width="50%">
      <hr style="margin-bottom: 20px" />
      <el-table :data="infoData" border style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="time"
          label="服务时间"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="frequency"
          label="频次"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="age"
          label="操作"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template>
            <el-button type="text" @click="listDialogVisible = true"
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom-page">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="query2.pageNum"
          :page-sizes="[10, 20, 40, 100]"
          :page-size="query2.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount2"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="infoDialogVisible = false"
          >确定</el-button
        >
        <el-button @click="infoDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 工单列表弹框 -->
    <el-dialog title="查看" :visible.sync="listDialogVisible" width="500px">
      <el-form label-width="90px" disabled>
        <el-form-item label="工单编号:">
          <el-input v-model="orderRow.orderNum" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="服务种类:">
          <!-- <el-select
  v-model="orderRow.serviceType"
  style="width: 100%"
>
  <el-option label="维护类服务" value="0"></el-option>
  <el-option label="保洁类服务" value="1"></el-option>
  <el-option label="生活照料类" value="2"></el-option>
</el-select> -->
          <el-select
            v-model="orderRow.serviceType"
            placeholder="请选择"
            style="width: 100%"
            size="medium"
          >
            <el-option
              v-for="item of serviceTypeList"
              :key="item.id"
              :label="item.serviceTypeName"
              :value="item.id + ''"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务产品:">
          <el-input
            v-model="orderRow.serveproductName"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间:">
          <el-input v-model="orderRow.timeStart" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="结束时间:">
          <el-input v-model="orderRow.timeEnd" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="服务时长:">
          <el-input v-model="orderRow.period" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="服务人员:">
          <el-input
            :value="
              orderRow.servePersonName +
              (orderRow.otherservePersonName
                ? '、' + orderRow.otherservePersonName
                : '')
            "
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="listDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 查看工单信息弹框 -->
    <el-dialog title="查看" :visible.sync="recordDialogVisible" width="50%">
      <hr style="margin-bottom: 20px" />
      <el-form ref="recordFormRef" :model="recordForm" label-width="80px">
        <el-form-item label="主题培训:">
          <el-input v-model="recordForm.theme" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="主讲人:">
          <el-input
            v-model="recordForm.speaker"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="培训时间:">
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="请选择开始时间"
              v-model="recordForm.date1"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="2">至</el-col>
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="请选择结束时间"
              v-model="recordForm.date1"
              style="width: 100%"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="培训地点:">
          <el-input v-model="recordForm.site" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="培训技能:">
          <el-input v-model="recordForm.skill" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="培训内容:">
          <quillEditor></quillEditor>
        </el-form-item>
        <el-form-item label="参与情况:">
          <el-input
            v-model="recordForm.condition"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="培训表现:">
          <el-input
            v-model="recordForm.manifestation"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 查看服务人员信息弹框 -->
    <el-dialog
      title="查看信息"
      :visible.sync="viewServerDialogVisible"
      width="50%"
    >
      <hr style="margin-bottom: 20px" />
      <el-form ref="form" :model="serverInfoForm" label-width="120px" disabled>
        <el-form-item label="姓名：">
          <el-input v-model="serverInfoForm.personName"></el-input>
        </el-form-item>
        <el-form-item label="性别：">
          <el-select
            v-model="serverInfoForm.personSex"
            placeholder="请选择性别"
            style="width: 100%"
          >
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号码：">
          <el-input v-model="serverInfoForm.personPhone"></el-input>
        </el-form-item>
        <el-form-item label="地址：">
          <el-input v-model="serverInfoForm.personAge"></el-input>
        </el-form-item>
        <el-form-item label="职位：">
          <el-input v-model="serverInfoForm.graduateUniversity"></el-input>
        </el-form-item>
        <el-form-item label="性别：">
          <el-select
            v-model="serverInfoForm.education"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option label="本科" value="0"></el-option>
            <el-option label="专科" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址：">
          <el-input v-model="serverInfoForm.address"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request.js"
import baseURL from "@/api/baseURL"
import "@/utils/addToolbar"
import AMap from "AMap" // 引入高德地图
import { quillEditor } from "vue-quill-editor"
import { chekCode } from "@/views/elderManage/util.js"
import moment from "moment"
import headLine from "../../components/headline"

export default {
  components: {
    quillEditor,
    headLine,
  },
  data() {
    var chekPhone = (rule, value, callback) => {
      let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (!validatePhone.test(value)) {
        return callback(new Error("手机号格式错误"))
      }
      callback()
    }
    var checkIdCode = (rule, value, callback) => {
      if (!chekCode(value)) {
        return callback(new Error("身份证号格式错误"))
      }
      callback()
    }
    return {
      formDataRules: {
        serviceStaffId: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        // loginName: [
        //   {
        //     required: true,
        //     message: "请输入登录名称",
        //     trigger: "blur",
        //   },
        // ],
        personSex: [
          // { required: true, message: "请选择性别", trigger: "blur" },
        ],
        isWork: [
          {
            required: true,
            message: "请选择是否是工作人员",
            trigger: "blur",
          },
        ],
        personPhone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        personIdentity: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
          { validator: checkIdCode, trigger: "blur" },
        ],
      },
      titleList: [
        {
          id: "1",
          name: "基本信息",
        },
        {
          id: "2",
          name: "工单信息",
        },
      ],
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.formData.videoEndTime
          if (endDateVal) {
            return (
              time.getTime() >
              new Date(endDateVal).getTime() - 1 * 1 * 60 * 60 * 1000
            )
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.formData.videoStartTime
          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() + 1 * 1 * 60 * 60 * 1000
            )
          }
        },
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      orgLevels: "",
      totalCount4: 0,
      tempTableChekbox: [
        "序号",
        "姓名",
        "性别",
        "手机号码",
        "年龄",
        "地址",
        "机构点",
        "操作",
      ],
      tableChekbox: [
        "序号",
        "姓名",
        "性别",
        "手机号码",
        "年龄",
        "地址",
        "机构点",
        "操作",
      ],
      loading: false,
      options: [],
      totalCount3: 0,
      query3: {
        pageNum: 1,
        pageSize: 10,
      },
      totalCount2: 0,
      query2: {
        pageNum: 1,
        pageSize: 10,
      },
      formData: {
        serviceStationName: "",
        personPhoto: "",
        shequId: "",
        longitude: "",
        latitude: "",
        serviceStaffId: "",
        address: "",
        serviceId: "",
        intervalTime: 5,
        checkAddress:"0",
        canSelectAllCustomer:'1',
        canInvalid:'0'
        // belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
      },
      nodata: "加载中",
      formData1: {
        serviceStaffId: "",
      },
      orgList: [],
      dialogTitle: "",
      certifiDialog: "",
      totalCount1: 0,
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      polygons: [],
      communityList: [],
      certificateAll1: [],
      certificateAll2: [],
      certifiNameAll1: [],
      myMap: null,
      isMap: true,
      marker: [],
      serviceTypeList: [],
      // 服务人员信息
      serverInfoForm: {},
      // 新增证书信息弹框
      certificateForm: {
        servicePersonId: "",
        certificateType: "",
        certificateName: "",
        certificateCode: "",
        certificateTime: "",
        photo: "",
      },
      controlAddContent: 1, // 控制新增弹框内部内容的切换
      controlGongdanInfo: true, // 控制工单信息弹框内容的切换

      // 工单信息信息
      recordForm: {
        theme: "",
        speaker: "",
        date1: "",
        date2: "",
        site: "",
        skill: "",
        condition: "",
        manifestation: "",
      },
      // 培训信息
      recordData: [],
      // 基本信息

      query: {
        personName: "", // 姓名
        mobilePhone: "", // 联系方式
        education: "", // 性别
        // belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
      },
      list: [],
      // 表格数据
      tableData: [],
      addPersonnelDialogVisible: false, // 新增弹框的显示与隐藏
      infoDialogVisible: false, // 工单信息弹框的显示与隐藏
      listDialogVisible: false, // 工单列表弹框的显示与隐藏
      recordDialogVisible: false, // 查看工单信息弹框的显示与隐藏
      dialogVisible: false, // 工单列表查看弹框的显示与隐藏
      certificateDialogVisible: false, // 新增证书信息弹框的显示与隐藏
      viewServerDialogVisible: false, // 查看服务人员信息弹框的显示与隐藏
      infoData: [],
      // 工单列表数据
      gongdanData: [
        {
          sername: "定时查房服务",
          startTime: "2021-01-01  14:21",
          endTime: "2021-01-01  15:21",
          schedule: "1/2",
          state: 1,
        },
      ],
      approvalStatus: "",
      name: "",
      pageNo: 1,
      pageSize: 10,
      cerIndex: 0,
      getServerId: "",
      servestation: {
        pageNo: 1,
        pageSize: 5,
        count: 0,
        list: [],
      },
      serviceStationName: "",
      datePicker: [],
      servicePoint: true,
      orderRow: {},
      normalInfo: {},
    }
  },
  inject: ["reload"], //注入
  created() {
    this.formData = {
      personName: "",
      personSex: "",
      isWork: "",
      personPhone: "",
      personIdentity: "",
      serviceStaffId: "",
      address: "",
      intervalTime: 5,
      checkAddress:'0',
      canSelectAllCustomer:'1',
        canInvalid:'0'
    }
    this.baseUrl =
      baseURL + "/jjyl/controller/uploadController/info/uploadPhoto"
    this.getProvince()
    this.getDataList()
    // this.getCertificateList()
    // this.getCertiNameList()
    this.getServiceTypeList()
    //this.getchangeList()
  },
  watch: {
    // options: {
    //     handler(newVal) {
    //         console.log("深度监听", newVal.length)
    //         if (newVal.length > 0) {
    //             this.nodata = "加载中"
    //         }
    //     },
    //     deep: true,
    // },
  },
  mounted() {
    this.getOrg()
  },

  methods: {
    orderClick(row) {
      this.listDialogVisible = true
      this.orderRow = row
    },
    // 身份证获取信息
    idCardchange(val) {
      // 年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (
        val.substring(10, 12) < month ||
        (val.substring(10, 12) == month && val.substring(12, 14) <= day)
      ) {
        age++
      }
      this.formData.personAge = age
      if (parseInt(val.substr(16, 1)) % 2 == 1) {
        this.formData.personSex = "1"
        //是男则执行代码 ...
      } else {
        this.formData.personSex = "2"
        //是女则执行代码 ...
      }
    },
    //之前的选中事件
    servestationRow(row) {
      // alert(row.statName)
      if (this.dialogTitle != "查看") {
        this.$nextTick(() => {
          this.formData.serviceStationId = row.id
          this.formData.serviceStationName = row.statName
          this.$forceUpdate()
        })
      }
    },
    getServestation() {
      this.$http
        .request({
          url: "/jjyl/admin/serviceStation/info/findList",
          method: "POST",
          data: {
            pageNo: this.servestation.pageNo,
            pageSize: this.servestation.pageSize,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.content) {
              this.servestation = res.content
            } else {
              this.servestation = {
                pageNo: 1,
                pageSize: 5,
                count: 0,
                list: [],
              }
            }
          }
        })
    },
    servestationSize(val) {
      this.servestation.pageNo = val
      this.getServestation()
    },
    servestationChange(val) {
      this.servestation.pageNo = 1
      this.servestation.pageSize = val
      this.getServestation()
    },
    // 数据状态发生改变
    onStatusChange(row) {
      let url =
        row.nonUse === 0
          ? "/jjyl/WebServeperson/info/stopServeperson"
          : "/jjyl/WebServeperson/info/startServeperson"
      this.$http
        .request({
          url,
          method: "POST",
          data: {
            id: row.id,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`修改状态成功`)
          } else {
            this.$message.success(`修改状态失败`)
          }
          this.getDataList()
        })
    },
    getchangeList(query, query1) {
      this.$http
        .request({
          url: "/ypt/admin/serviceStaff/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: -1,
            personName: query,
            personIdentity: query1,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.options = res.content.list
            } else {
              this.options = []
            }
            this.loading = false
          }
        })
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true
        this.getchangeList(query, "")
      } else {
        this.options = []
      }
    },
    remoteMethod1(query) {
      if (query !== "") {
        this.loading = true
        this.getchangeList("", query)
      } else {
        this.options = []
      }
    },

    async handleSelect(val) {
      let item = {}
      this.options.forEach((item) => {
        if (item.id == val) {
          this.formData = JSON.parse(JSON.stringify(item))
          console.log(item)
          this.formData.serviceStaffId = val

          if (item.position) {
            this.$set(this.formData, "position", item.position)
          }
          if (item.provinceId) {
            this.$set(this.formData, "provinceId", item.provinceId)
            this.$set(this.formData, "cityId", item.cityId)
            this.$set(this.formData, "areaId", item.zoneId)
            this.$set(this.formData, "streetId", item.streetId)
            this.$set(this.formData, "shequId", item.shequId)
            this.$set(this.formData, "address", item.address)
            this.$set(this.formData, "longitude", item.longitude)
            this.$set(this.formData, "latitude", item.latitude)
          }
        }
      })
      let self = this
      this.formData.address = this.formData.address
      this.formData.lifeAreas = String(this.formData.lifeAreas)
      this.formData.minzhengIndex = String(this.formData.minzhengIndex)
      this.formData.provinceId = String(this.formData.provinceId)
      if (!this.formData.provinceId) return
      let city = await this.getDistricts(this.formData.provinceId)
      this.cityList = city.districtList
      if (!this.formData.cityId) return
      this.formData.cityId = String(this.formData.cityId)
      let area = await this.getStreetList(this.formData.cityId)
      this.areaList = area
      if (!this.formData.areaId) return
      this.formData.areaId = String(this.formData.areaId)
      let street = await this.getStreetList(this.formData.areaId)
      self.streetList = street
      if (!this.formData.streetId) return
      this.formData.streetId = String(this.formData.streetId)
      let communityList = await this.getStreetList(this.formData.streetId)
      this.communityList = communityList
      this.formData.shequId = Number(this.formData.shequId) //社区
      this.formData.checkAddress='0'
      // this.formData1 = this.formData
      // console.log(this.formData1, "this.formData1")
      this.loadMap()
      setTimeout(() => {
        this.potintMap()
      }, 500)
      let issure = ""
      this.issure = true
      this.$forceUpdate()
    },
    //监控姓名是否为空
    clearForm(val) {
      if (val) {
        if (this.dialogTitle == "新增") {
          this.$set(this.formData, "serviceStaffId", "")
          this.formData = {}
          this.formData.checkAddress='0'
          this.changeFirst()
        }
      }
    },
    //监控身份证是否为空
    clearForm1(val) {
      if (val) {
        if (this.dialogTitle == "新增") {
          this.$set(this.formData, "serviceStaffId", "")
          this.formData = {}
          this.changeFirst()
        }
      }
    },
    changeIdx(id) {
      this.controlAddContent = id
      this.getServerList()
    },
    changeAge() {
      this.formData.personAge =
        moment().format("YYYY") - this.formData.personIdentity.slice(6, 10)
    },
    // 页面刷新
    Reset() {
      this.reload()
    },
    //table列checkbox发生变化
    tableChekboxChange(val) {
      this.tempTableChekbox = val.map((item) => item)
    },
    lookCer1(title, data) {
      this.certificateDialogVisible = true
      this.certifiDialog = title
      if (title != "新增") {
        this.certificateForm.servicePersonId = data.servicePersonId
        this.certificateForm.certificateType = data.certificateType
        this.certificateForm.certificateName = data.certificateName
        this.certificateForm.certificateCode = data.certificateCode
        this.certificateForm.certificateTime = data.certificateTime
        this.certificateForm.photo = data.photo
      }
    },
    lookCer2(title, data, index) {
      this.cerIndex = index
      this.certificateDialogVisible = true
      this.certifiDialog = title
      this.certificateForm.servicePersonId = data.servicePersonId
      this.certificateForm.certificateType = data.certificateType
      this.certificateForm.certificateName = data.certificateName
      this.certificateForm.certificateCode = data.certificateCode
      this.certificateForm.certificateTime = data.certificateTime
      this.certificateForm.photo = data.photo
    },
    closeAddCer() {
      this.certificateForm = {
        servicePersonId: "",
        certificateType: "",
        certificateName: "",
        certificateCode: "",
        certificateTime: "",
        photo: "",
      }
    },
    //确认按钮
    confirmSave() {
      let self = this
      // console.log(self.formData, self.formData1)
      // self.formData = self.formData1
      this.$refs.addformRef.validate((valid) => {
        if (valid) {
          if (
            self.formData.isUploadVideo == "是" &&
            !self.formData.videoStartTime
          ) {
            self.$message.error("视频开始时间不能为空")
            return
          }
          if (
            self.formData.isUploadVideo == "是" &&
            !self.formData.videoEndTime
          ) {
            self.$message.error("视频结束时间不能为空")
            return
          }
          if (!self.formData.provinceId) {
            self.$message.error("省级地址为必填项，请选择")
            return
          }
          if (!self.formData.cityId) {
            self.$message.error("市级地址为必填项，请选择")
            return
          }
          if (!self.formData.areaId) {
            self.$message.error("区县级地址为必填项，请选择")
            return
          }
          if (!self.formData.streetId) {
            self.$message.error("街道地址为必填项，请选择")
            return
          }
          if (
            self.formData.shequId === "" ||
            self.formData.shequId === null ||
            self.formData.shequId === undefined
          ) {
            self.$message.error(
              "社区为必填项，请选择,如无对应社区，请地址管理配置"
            )
            return
          }
          // if (!self.formData.address) {
          //     self.$message.error(
          //         "详细信息为必填项，请在地图的边界内点击选择或手动输入"
          //     )
          //     return
          // }
          if (this.dialogTitle === "新增") {
            this.formData.id = ""
          }
          if (this.dialogTitle === "编辑") {
            this.formData.serviceStaffId = this.formData.serviceId
          }
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })
          this.$http
            .request({
              url: "/jjyl/admin/serviceStaffCustomerCenter/info/insert",
              method: "POST",
              data: {
                ...this.formData,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                this.addPersonnelDialogVisible = false
                this.getDataList()
                this.$message({
                  message: "操作成功",
                  type: "success",
                })
                loading.close()
              } else {
                loading.close()
              }
            })
            .catch((error) => {
              this.addPersonnelDialogVisible = false
              loading.close()
            })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    workOrder(data) {
      this.infoDialogVisible = true

      this.getServerId = data.id
      this.getServerList()
    },
    //服务工单列表
    getServerList() {
      if (this.dialogTitle !== "新增") {
        this.$http
          .request({
            url: "/jjyl/servicePgd/info/findServicepgdByServepersonIDNew",
            method: "POST",
            data: {
              servePerson_id: this.getServerId,
              ...this.query2
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (res.content == null || res.content == "null") {
                this.infoData = []
                return
              }
              this.infoData = res.content.list
              this.totalCount2=res.content.count
            }
          })
      }
    },
    // 证书类型
    getCertificateList() {
      request({
        url: "/jjyl/admin/ststemdata/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: -1,
          status: "0",
          type: "5",
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content) {
            this.certificateAll2 = res.content.list
          } else {
            this.certificateAll2 = []
          }
        }
      })
    },
    // 证书名称
    getCertiNameList(val) {
      request({
        url: "/jjyl/admin/ststemdata/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: -1,
          type: "3",
          status: "0",
          cutId: val,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content) {
            this.certifiNameAll1 = res.content.list
          } else {
            this.certifiNameAll1 = []
          }
        }
      })
    },
    // 获取表格数据
    getDataList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.query,
      }
      this.$http
        .request({
          url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.totalCount1 = 0
              return
            }
            this.tableData = res.content.elderList.list
            this.totalCount1 = res.content.elderList.count
          } else {
            this.$message({
              message: "查询或获取失败",
              type: "error",
            })
          }
        })
    },
    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },
    handleEditNodeClick(data, node) {
      const clickNode = this.$refs.tree.getNode(node)
      const arr = []
      this.loopNode(clickNode, arr)
      this.arrOrgList = arr
      // let obj = common1.organization(this.arrOrgList, this.orgLevels)
      this.$set(this.formData, "orgId", data.orgId)
      this.$set(this.formData, "parentId", data.parentId)
      this.$set(this.formData, "orgType", data.orgType)
      this.$set(this.formData, "orgName", data.label)

      this.$set(this.formData, "qujiId", obj.qujiId)
      this.$set(this.formData, "shengjiId", obj.shengjiId)
      this.$set(this.formData, "shijiId", obj.shijiId)
      this.$set(this.formData, "stationId", obj.stationId)
      this.$set(this.formData, "shequjiId", obj.shequjiId)
      this.$refs["selectBoxRef"].handleClose()
    },
    // 输入地址
    getMap(input) {
      const self = this
      const autoOptions = {
        city: this.formData.areaId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData.address = e.poi.name
        self.formData.longitude = e.poi.location.lng
        self.formData.latitude = e.poi.location.lat
        self.potintMap()
      })
    },
    //获取组织机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            this.changeFirst()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async changeFirst() {
      // console.log(
      //     this.normalInfo,
      //     "机构信息 normalInfo.orgLevel",
      //     this.provinceList
      // )
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getStreetList(this.normalInfo.cityId)
        this.areaList = areaList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getStreetList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.latitude && this.normalInfo.longitude) {
        this.formData.latitude = this.normalInfo.latitude
        this.formData.longitude = this.normalInfo.longitude
      } else {
        if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
          this.provinceList.forEach((item) => {
            if (item.adcode == this.normalInfo.provinceId) {
              this.formData.latitude = item.center.lat
              this.formData.longitude = item.center.lng
            }
          })
        } else if (this.normalInfo.orgLevel == 2) {
          this.cityList.forEach((item) => {
            if (item.adcode == this.normalInfo.cityId) {
              this.formData.latitude = item.center.lat
              this.formData.longitude = item.center.lng
            }
          })
        } else if (this.normalInfo.orgLevel == 3) {
          this.areaList.forEach((item) => {
            if (item.adcode == this.normalInfo.areaId) {
              // this.formData.latitude = item.center.lat
              // this.formData.longitude = item.center.lng
            }
          })
        } else if (
          this.normalInfo.orgLevel == 4 ||
          this.normalInfo.orgLevel == 5
        ) {
          this.streetList.forEach((item, index) => {
            if (item.addCode == this.normalInfo.streetId) {
              // this.formData.latitude = item.latitude
              // this.formData.longitude = item.longitude
            }
          })
        }
      }
      this.potintMap()

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = Number(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }

      this.formData.provinceId = this.normalInfo.provinceId
      console.log(this.provinceList, this.formData.provinceId, "省")
      this.formData.cityId = this.normalInfo.cityId
      this.formData.address =
        this.normalInfo.address == null ? "" : this.normalInfo.address
      this.formData.areaId = this.normalInfo.areaId
      this.formData.streetId = this.normalInfo.streetId
      this.formData.shequId = this.normalInfo.communityId
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    // 打点
    potintMap() {
      var map = new AMap.Map("container1", {
        resizeEnable: true,
        zoom: 8,
        // zooms: [3, 20],
        expandZoomRange: true,
        center: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
      })
      var marker = new AMap.Marker({
        position: [
          Number(this.formData.longitude),
          Number(this.formData.latitude),
        ],
        map: map,
      })
      map.setFitView(marker)
    },
    // 获取省市区
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          // console.log(err);
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    //街道地址发生变化
    async streetChange(val) {
      this.formData.shequId = ""
      let communityList = await this.getStreetList(val)
      this.communityList = communityList
      this.joinAddress()
    },
    addPersonnelHandle(title, row) {
      this.controlAddContent = "1"
      this.dialogTitle = title
      this.addPersonnelDialogVisible = true
      this.servestation.list = []
      this.getServestation()
      let self = this
      setTimeout(async () => {
        await self.$nextTick(() => self.loadMap())
      }, 30)
      if (self.dialogTitle == "编辑" || self.dialogTitle == "查看") {
        this.getServerId = row.id
        self.look(row)
      } else {
        this.changeFirst()
        this.formData.checkAddress='0'
       this.formData.canSelectAllCustomer='1'
        this.formData.canInvalid='0'
      }
    },
    createExcel(){
      this.request2({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/exportServiceStaff",
        method: "POST",
        excel: true,
        data: {
          ...this.query
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "服务人员.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    // 查看
    look(date) {
      let self = this
      let params = {
        id: date.id,
      }
      this.$http
        .request({
          url: "/jjyl/admin/serviceStaffCustomerCenter/info/getById",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            self.formData = { ...res.content }
            let jsonTemp = { ...res.content }
            self.formData.videoEndTime = jsonTemp.videoEndTime
            self.formData.videoStartTime = jsonTemp.videoStartTime
            this.formData.serviceId = jsonTemp.serviceStaffId
            this.formData.serviceStaffId = jsonTemp.personName
            this.formData.intervalTime = jsonTemp.intervalTime || 5

            self.formData.areaId = jsonTemp.areaId
              ? String(jsonTemp.areaId)
              : ""
            self.formData.cityId = jsonTemp.cityId
              ? String(jsonTemp.cityId)
              : ""
            self.formData.provinceId = jsonTemp.provinceId
              ? String(jsonTemp.provinceId)
              : ""
            self.formData.streetId = jsonTemp.streetId
              ? String(jsonTemp.streetId)
              : ""
            self.formData.shequId = jsonTemp.shequId
              ? Number(jsonTemp.shequId)
              : ""
            self.formData.longitude = jsonTemp.longitude
            self.formData.latitude = jsonTemp.latitude
            if (!self.formData.provinceId) return
            let city = await self.getDistricts(self.formData.provinceId)
            self.cityList = city.districtList
            console.log(self.cityList, "城市")
            if (!self.formData.cityId) return
            let area = await self.getStreetList(self.formData.cityId)
            self.areaList = area
            console.log(self.areaList, "社区")
            if (!self.formData.areaId) return
            let street = await self.getStreetList(self.formData.areaId)
            self.streetList = street
            console.log(self.streetList, "街道")
            if (!self.formData.shequId) return
            let communityList = await self.getStreetList(self.formData.streetId)
            self.communityList = communityList
            console.log(communityList, "街道地市")
            if (self.formData.latitude && self.formData.longitude) {
              this.potintMap()
            }

            this.$forceUpdate()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.cityId = ""
      this.formData.areaId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.myMap = new AMap.Map("container1", {
          resizeEnable: true,
          zoom: 8,
        })
        resolve()
      })
    },
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData.areaId = ""
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      let area = await this.getStreetList(val)
      this.areaList = area
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData.streetId = ""
      this.formData.shequId = ""
      this.formData.address = ""
      // val = val.replace(/.$/, "");
      let streetList = await this.getStreetList(val)
      this.streetList = streetList
      this.joinAddress()
    },

    //社区地址发生变化
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.formData.shequId = val
        this.$forceUpdate()
        this.joinAddress()
      })
    },
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          // console.log(err);
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log("移除地图编辑出错了")
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.formData.address = address
                        self.formData.latitude = lnglat.lng
                        self.formData.longitude = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([params.longitude, params.latitude])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel

        if (!address) {
          self.formData.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        console.log(self.formData.address)
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({
          city: "",
        })
        self.marker = new AMap.Marker()
        console.log(this.formData.address)
        geocoder.getLocation(this.formData.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData.longitude = lnglat.lng
            self.formData.latitude = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    QuerySearch() {
      this.getDataList()
    },
    emptySearch() {
      //清空搜索条件
      this.query = {}
      this.getDataList()
    },
    handleSizeChange(val) {},
    handleCurrentChange(val) {},

    handleCurrentChange1(val) {
      this.pageNo = val
      this.getDataList()
    },
    handleSizeChange1(val) {
      this.pageSize = val
      this.getDataList()
    },
    handleSizeChange2(val) {
      this.query2.pageSize = val
      this.getServerList()
    },
    handleCurrentChange2(val) {
      this.query2.pageNum = val
      this.getServerList()
    },
    handleSizeChange3(val) {},
    handleCurrentChange3(val) {},
    handleAvatarSuccess(res, file) {
      // this.formData.photo = res.content
      this.$set(this.formData, "personPhoto", res.content)
      console.log(this.formData.photo, res.content)
    },
    handleAvatarSuccess1(res, file) {
      this.certificateForm.photo = res.content
    },
    beforeAvatarUpload1(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isJPG && isLt2M
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg"
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isJPG && isLt2M
    },
    closeAddDialog() {
      this.formData = {
        serviceStationName: "",
        photo: "",
        shequId: "",
        address: "",
        // belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
      }
      this.$refs.addformRef.resetFields()
      // this.servicePoint = false
      //
      // setTimeout(() => {
      //   this.servicePoint = true
      // }, 200)
      this.servestation = {
        pageNo: 1,
        pageSize: 5,
        count: 0,
        list: [],
      }

      this.infoData = []
      this.getServestation()
    },
    // 查看服务人员信息
    viewServerInfo(data) {
      this.viewServerDialogVisible = true
      this.serverInfoForm = data
    },
    deleteHandle(row) {
      this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/admin/serviceStaffCustomerCenter/info/deleteById",
          method: "POST",
          data: {
            id: row.id,
          },
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功")
            this.getDataList()
          }
        })
      })
    },
    changeView() {
      this.$forceUpdate()
    },
    // 获取服务种类
    getServiceTypeList() {
      request({
        url: "/jjyl/admin/type/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 999,
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content.list || []
          // 过滤开启状态的服务种类
          this.serviceTypeList = arr.filter((item) => {
            return item.status == 1
          })
        } else {
          this.$message.error("获取服务种类失败")
        }
      })
    },
  },
}
</script>

<style lang="less" scpoe>
.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-bottom {
  width: 100%;
  text-align: center;
}

.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}

.operation-color:hover {
  color: #00aaff;
}

.bottom-page {
  margin: 20px 0;
}

.btn_group {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

.dialog-footer {
  width: 100%;
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.collegebox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.infoBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.serviceInfoBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.rightBox {
  margin-left: 30px;
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.row-bg {
  margin-bottom: 20px;
}

.rightBox {
  margin-left: 30px;
  text-align: center;
}

.uploadBtn {
  width: 178px;
  height: 50px;
  margin-left: 5px;
  background-color: #66b1ff;
  color: #fff;
  font-size: 18px;
  border-radius: 5px;
  line-height: 50px;
  margin-top: 20px;
}

.el-dialog__body {
  padding-top: 0;
}
</style>
